// components/CtaBand.js
//
// A reusable "Call To Action" banner used at the bottom of most pages.
// This shows a key React concept: PROPS
//
// Props are like parameters/arguments — they let you customise a component
// from the outside. Here the parent passes in title, text, and buttons.
//
// Usage example:
//   <CtaBand
//     title="Ready to Begin?"
//     text="Let's discuss your vision."
//     buttons={[{ label: 'Book Now', to: '/contact', variant: 'primary' }]}
//   />

import React from 'react';
import { useNavigate } from 'react-router-dom';

// Destructure props directly in the function signature — very common React pattern
export default function CtaBand({ title, text, buttons = [] }) {
  const navigate = useNavigate();

  return (
    <div className="cta-band">
      <div className="container">
        <h2>{title}</h2>
        {text && <p>{text}</p>}
        <div className="btns">
          {/* Map over the buttons array to render each one */}
          {buttons.map((btn, i) => (
            <button
              key={i}
              className={btn.variant === 'outline' ? 'btn-outline' : 'btn-primary'}
              onClick={() => navigate(btn.to)}
            >
              {btn.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
